import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, RECONNECTING_MESSAGE } from "@/context/AuthContext";
import { useHomePath, useModePending } from "@/lib/uiMode";
import { SHELL } from "@/constants/testIds";
import Login from "@/pages/Login";

/**
 * `/login`: quem já tem sessão não vê o formulário, vai para casa.
 *
 * P0.6 — o salto espera pelo modo. Terminar o login e aterrar no Dashboard
 * para logo a seguir saltar para `/hoje` era o flash mais visível de todos,
 * porque acontecia a cada início de sessão. Ver `isModePending`: só o
 * operador espera; gestor e admin decidem já, como sempre decidiram.
 */
export default function LoginGate() {
  const { status, reconnecting } = useAuth();
  const homePath = useHomePath();
  const modePending = useModePending();

  if (status === "loading" || (status === "authed" && modePending)) {
    return (
      <div
        data-testid={SHELL.routeLoading}
        className="min-h-screen flex items-center justify-center bg-surface-bg text-ink-secondary text-sm"
      >
        {reconnecting ? RECONNECTING_MESSAGE : "A carregar…"}
      </div>
    );
  }
  if (status === "authed") return <Navigate to={homePath} replace />;
  return <Login />;
}
